import { Form, Card } from "antd"
import ForgotPasswordForm from "../../components/monaliza/authentication/ForgotPasswordForm"
import { forgotPasswordAsync } from "../../app/store/reducers/auth/authReducer"



const ForgetPassword = () => {

  const onFinish = (values) => {
    console.log("values", values)

    forgotPasswordAsync({email: values?.email})
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      })
  }

    
  return (
    <>
      <Form
      name="forgotPassword"
      onFinish={onFinish}
      initialValues={{}}
      scrollToFirstError
      style={{
        width: "550px"
      }}
    >
        <Card style={{height: "50vh"}}>
          <Card.Meta
            title="Forgot your password?"
            description="Enter your email and we'll send you a reset link."
            className="mb-2"
          />
          <ForgotPasswordForm/>
        </Card>
        </Form>
    </>
  )
}

export default ForgetPassword;